import './App.css';
import Modal from './lib/components/Modal';

function App() {
  return (
    <><Modal/></>
  );
}

export default App;
